import { useEffect, useState, useContext } from "react";
import { projectAuth } from "../firebase/config";
import { useAuthContext } from "./useAuthContext";
import { ProductsContext } from "../context/products.context";
export const useLogout = () => {
  const [isCancelled, setIsCancelled] = useState(false);
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const { dispatch } = useAuthContext();
  const { setDefaultDistrict, setSelectableDistricts } = useContext(ProductsContext);
  const logout = async () => {
    setError(null);
    setIsPending(true);

    try {
      //change district to null
      await setDefaultDistrict(null);
      // also drop the previous session's district list, otherwise the navbar
      // Select mounts on the next login before the new user doc has loaded
      setSelectableDistricts(null);

      // sign the user out
      await projectAuth.signOut();

      // dispatch logout action
      dispatch({ type: "LOGOUT" });

      // update state
      if (!isCancelled) {
        setIsPending(false);
        setError(null);
      }
    } catch (err) {
      if (!isCancelled) {
        setError(err.message);
        setIsPending(false);
      }
    }
  };

  useEffect(() => {
    return () => setIsCancelled(true);
  }, []);

  return { logout, error, isPending };
};
